import React from 'react';
import classNames from 'classnames';
import './ChoiceSeparator.less';

export interface IChoiceSeparatorProps {
  className?: string;
  /**
   * Separator orientation.
   * Horizontal separator is used for vertical list and vertical for horizontal one.
   */
  orientation: 'horizontal' | 'vertical';
  /**
   * Indicates whether need to show separator lines
   *
   * @default true
   */
  hasLines?: boolean;
}

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ChoiceSeparator({ orientation, className, hasLines = true }: IChoiceSeparatorProps) {
  return (
    <li
      className={classNames(
        'dpc-choice-separator',
        {
          'dpc-choice-separator--horizontal': orientation === 'horizontal',
          'dpc-choice-separator--vertical': orientation === 'vertical',
          'dpc-choice-separator--no-lines': !hasLines,
        },
        className
      )}
      role="separator"
    >
      <span className="dpc-choice-separator__text">Or</span>
    </li>
  );
}
